const ROLES = {
  ADMIN: "ADMIN",
  USER: "USER",
  MANAGER: "MANAGER",
};

export default Object.freeze({
  ...ROLES,
  validate: (role) => {
    return ROLES.hasOwnProperty(role);
  },
});
